import { shipmentTermFilter } from '../normalizers/uiNeeds';
import { CQ_POTS } from '../../catalogConstants';
import { commonTypes } from '../common';

export const types = {
  SET_UPDATE_CQ_NEEDS: 'UINEEDS/SET_UPDATE_CQ_NEEDS',
  SET_SEND_INSTALLATION_ADDRESS_IF_INSTALLER_SELECTED: 'UINEEDS/SET_SEND_INSTALLATION_ADDRESS_IF_INSTALLER_SELECTED',
};

export const initialState = {
  updateCQNeeds: {
    installation: null,
    payment: null,
    shipping: null,
    poitSelected: null,
    sendInstallationAddressIfInstallerSelected: false,
  },
};

const UINeedsUpdateCQReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_POIT_SELECTED: {
      const { poitSelected } = action.payload;
      let newState = { ...state };

      newState.updateCQNeeds.poitSelected = poitSelected.id;

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    case types.SET_SEND_INSTALLATION_ADDRESS_IF_INSTALLER_SELECTED: {
      let newState = { ...state };

      newState.updateCQNeeds.sendInstallationAddressIfInstallerSelected = true;

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    case types.SET_UPDATE_CQ_NEEDS: {
      const { choices, shippingStepAllowed } = action.payload;
      if (choices) {
        let newState = { ...state };
        choices.forEach((choice) => {
          switch (choice.type) {
            case CQ_POTS.INSTALLATION_POT.TYPE:
              newState.updateCQNeeds.installation = [
                ...choice.terms,
              ];
              break;
            case CQ_POTS.PAYMENT_POT.TYPE:
              newState.updateCQNeeds.payment = [
                ...choice.terms,
              ];
              break;
            case CQ_POTS.SHIPPING_POT.TYPE:
              newState.updateCQNeeds.shipping = shipmentTermFilter(choice.terms);
              break;
          }
        });
        newState.updateCQNeeds.shippingStepAllowed = shippingStepAllowed;
        return {
          state: newState,
          stepsMustBeEvaluated: true,
        };
      }
      break;
    }
    default:
      return null;
  }
};

export const actions = {
  setUpdateCQNeeds: (info) => ({
    type: types.SET_UPDATE_CQ_NEEDS,
    payload: {
      ...info
    },
  }),
  setSendInstallationAddressIfInstallerSelected: () => ({
    type: types.SET_SEND_INSTALLATION_ADDRESS_IF_INSTALLER_SELECTED,
  }),
};

export default UINeedsUpdateCQReducer;
